import { HttpStatusCode } from "axios";
import studentCourceDetailService from "../../apiServices/student/studentCourceDetailService";
import { setStudentCourceDetail } from "../../store/slices/student/studentCourceDetailSlice";

export function getStudentCourceDetail(semesterId: number) {
    return async function (dispatch: any, getState: any) {
      let response = await studentCourceDetailService.getCourceDetails(semesterId);
      if (response?.success === true) {
        dispatch(setStudentCourceDetail(response.data));
      } else {
        console.log("error");
      }
    };
  }
